var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "-0.72 -0.72 25.44 25.44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#000000",
    strokeWidth: 0.00024000000000000003,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000",
    strokeWidth: 1.152
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9935 5.00676L19.9983 5.12836L20 5.25V16.35C20 18.3658 18.3658 20 16.35 20H5.25C5.16844 20 5.08742 19.9977 5.007 19.9932C5.58285 20.8988 6.59621 21.5 7.75 21.5H16.35C19.1943 21.5 21.5 19.1943 21.5 16.35V7.75C21.5 6.59664 20.8992 5.5836 19.9935 5.00676ZM2 7.5V15.75C2 17.5449 3.45507 19 5.25 19H15.75C17.5449 19 19 17.5449 19 15.75V7.5H2ZM5.25 2C3.45507 2 2 3.45507 2 5.25V6H19V5.25C19 3.45507 17.5449 2 15.75 2H5.25Z",
    fill: "#9accc9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9935 5.00676L19.9983 5.12836L20 5.25V16.35C20 18.3658 18.3658 20 16.35 20H5.25C5.16844 20 5.08742 19.9977 5.007 19.9932C5.58285 20.8988 6.59621 21.5 7.75 21.5H16.35C19.1943 21.5 21.5 19.1943 21.5 16.35V7.75C21.5 6.59664 20.8992 5.5836 19.9935 5.00676ZM2 7.5V15.75C2 17.5449 3.45507 19 5.25 19H15.75C17.5449 19 19 17.5449 19 15.75V7.5H2ZM5.25 2C3.45507 2 2 3.45507 2 5.25V6H19V5.25C19 3.45507 17.5449 2 15.75 2H5.25Z",
    fill: "#9accc9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiple);
export default __webpack_public_path__ + "static/media/multiple.3067b2d00770b55450f53bc09be13272.svg";
export { ForwardRef as ReactComponent };